import { BoxMenuThemeModeConfig } from './types';

const dark: BoxMenuThemeModeConfig = {
  BoxMenu: {
    backgroundColor: '#505251',
    borderColor: '#267DAC',
    textColor: '#ffffff',
  },
};

export default dark;
